import React, { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";

const inputStates = {
  display: "display",
  editting: "editting",
};

export const EditableInput = ({
  name,
  value,
  onFocus,
  onChange,
  onBlur,
  style,
  refThing,
  validTest,
  className,
  helperText,
  acceptsNewLine = false,
  unfocusOnEnter,
  onKeyDown,
  resetStateNotif,
  forceFocus,
  refObject,
  index,
  applyMarginBottomOnEditing = true,
  ...props
}) => {
  const [inputState, setInputState] = useState(inputStates.display);
  const internalRef = useRef(null);
  useEffect(() => {
    setInputState(inputStates.display);
    // console.log("hi");
    // console.log(resetStateNotif);
  }, [resetStateNotif]);

  useEffect(() => {
    if (forceFocus) {
      setInputState(inputStates.editting);
    } else {
      // console.log(forceFocus);
      // console.log("no force focus");
      setInputState(inputStates.display);
    }
  }, [forceFocus]);

  const handleOnFocus = (e) => {
    onFocus && onFocus(e);
    setInputState(inputStates.editting);
  };
  const handleOnBlur = (e) => {
    // console.log(validTest);
    onBlur && onBlur(e);
    if (!validTest) {
      // console.log("no valid test");
      setInputState(inputStates.display);
    } else if (validTest(e.target.value)) {
      // console.log(validTest(e.target.value));
      setInputState(inputStates.display);
    } else {
      //seterror
      // console.log("NOT VALID");
    }
  };
  const handleKeyDown = (e) => {
    onKeyDown && onKeyDown(e);
    !acceptsNewLine && e.key === "Enter" && e.preventDefault();
    unfocusOnEnter && e.key === "Enter" && internalRef.current.blur();
    // console.log(internalRef);
  };

  return (
    <>
      {/* <span>{value}</span> */}
      <TextareaAutosize
        //using multiple refs on a single element as per:
        //https://stackoverflow.com/a/72519722/12156650
        ref={(element) => {
          refThing && (refThing.current = element);
          refObject && (refObject.current[index] = element);
          // refObject && console.log(refObject.current);

          internalRef.current = element;
        }}
        className={
          "form-control editable-input py-1 border-box " +
          (inputState === "display"
            ? " border-0 px-0"
            : applyMarginBottomOnEditing && " mb-1") +
          (className ? " " + className : "")
        }
        style={{
          ...style,
          wordBreak: "break-word",
          resize: "none",
          overflow: "hidden",
          //   overflowWrap: "break-word",
          textOverflow: "ellipsis",
        }}
        name={name}
        value={value}
        onKeyDown={handleKeyDown}
        onFocus={handleOnFocus}
        onChange={onChange}
        onBlur={handleOnBlur}
        {...props}
      />
    </>
  );
};
